import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `${ctx.brand} गुमनाम चैट होम`,
    languageButtonLabel: `भाषा`,
    languageModalTitle: `भाषा चुनें`,
    languageModalCloseLabel: `भाषा मेनू बंद करें`,
  },
  languageOptions: {
    'en-US': {
      label: `अंग्रेज़ी (संयुक्त राज्य)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `अंग्रेज़ी (केन्या)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `अंग्रेज़ी (नाइजीरिया)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `अंग्रेज़ी (सिंगापुर)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `पुर्तगाली (पुर्तगाल)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `पुर्तगाली (ब्राज़ील)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `जर्मन (जर्मनी)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `जर्मन (ऑस्ट्रिया)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `जर्मन (स्विट्ज़रलैंड)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `स्पेनिश (स्पेन)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `फ़्रेंच (फ़्रांस)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `इतालवी (इटली)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `डच (नीदरलैंड)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `पोलिश (पोलैंड)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `स्वीडिश (स्वीडन)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `डेनिश (डेनमार्क)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `फ़िनिश (फ़िनलैंड)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `नॉर्वेजियाई (नॉर्वे)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `आइसलैंडिक (आइसलैंड)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `जापानी (जापान)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `कोरियाई (दक्षिण कोरिया)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `चीनी (चीन)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `कैंटोनीज़ (हाँग काँग (चीन विशेष प्रशासनिक क्षेत्र))`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `वियतनामी (वियतनाम)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `थाई (थाईलैंड)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `इंडोनेशियाई (इंडोनेशिया)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `स्वाहिली (केन्या)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `हिन्दी (भारत)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `बंगाली (बांग्लादेश)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `मराठी (भारत)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `तेलुगू (भारत)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `फ़ारसी (ईरान)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `उर्दू (पाकिस्तान)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `पंजाबी (पाकिस्तान)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `नाइजीरियाई पिडगिन (नाइजीरिया)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `रूसी (रूस)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `अरबी (सऊदी अरब)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `अरबी (संयुक्त अरब अमीरात)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `अरबी (क़तर)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `الدارجة المغربية (मोरक्को)`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `तुर्की (तुर्किये)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `भाषा चुनें`,
    closeLabel: `भाषा मेनू बंद करें`,
  },
  languageHint: (ctx) => `बिना अकाउंट बनाए ${ctx.localesCount}+ लोकल्स में घूमिए।`,
  readPagePrompt: ({languageLabel}) => `इस पेज को ${languageLabel} में पढ़ें।`,
};
